import * as React from 'react';
import {useState} from 'react';
import {injectIntl} from 'react-intl';
import {Redirect, Route, RouteComponentProps, Switch, withRouter} from "react-router";
import Login from './components/forms/login';
import MfaSetup from "./components/forms/mfaSetup";
import ForgotPassword from "./components/forms/forgotPassword";
import MfaValidation from "./components/forms/mfaValidation";
import PasswordReset from "./components/forms/passwordReset";
import CitySelector from "./components/forms/citySelector";
import Blank from "./components/blank";
import ChangePassword from "./components/forms/changePassword";
import {CognitoUser} from "amazon-cognito-identity-js";
import {Auth as AuthClient, Hub} from "aws-amplify";
import handleRedirect from "./utils/redirectHelper";

interface OwnProps {
    stage: string;
    isViaForSchools: boolean;
    queryParams: string;
    cognitoUserPool: string;
    cognitoAppClientID: string;

}

export enum ChangePwPageMode { FORGOT_CONFIRM, RESET_PW }

type Props = OwnProps & RouteComponentProps;

const Auth = (parentProps: Props) => {
    const [ user, setUser ] = useState({ user: null});
    const { stage, isViaForSchools,
        queryParams, history} = parentProps;

    Hub.listen('auth', (data) => {
        const { payload } = data;
        if (payload.event === 'signIn') {
            handleRedirect(history, queryParams)
        }
        if(payload.event === "customOAuthState") {
            const queryParamsString = payload.data ? `?redirect_uri=${payload.data}` : null;
            handleRedirect(history, queryParamsString)
        }
    });

    return (
        <Switch>
            <Route
                path='/loading'
                component={(props: any) => <Blank/>}
                />
            <Route
                path='/login'
                component={(props: any) => <Login {...props}
                                                  queryParams={queryParams}
                                                  isViaForSchools={isViaForSchools}
                                                  setUser={(cognitoUser: CognitoUser | any) =>
                                                  {setUser({user: cognitoUser}); }}
                                                  authClient={AuthClient}
                />}
            />
            <Route
                exact={true}
                path='/mfaSetup'
                component={(props: any) => <MfaSetup {...props} user={user}
                                                     isViaForSchools={isViaForSchools}
                                                     queryParams={queryParams}
                                                     authClient={AuthClient}/>}
            />
            <Route
                exact={true}
                path='/mfaValidation'
                component={(props: any) => <MfaValidation {...props} user={user}
                                                          isViaForSchools={isViaForSchools}
                                                          queryParams={queryParams}
                                                          authClient={AuthClient}/>}
            />
            <Route
                exact={true}
                path='/changePassword'
                component={(props: any) => <ChangePassword {...props} user={user}
                                                           isViaForSchools={isViaForSchools}
                                                           queryParams={queryParams}
                                                           authClient={AuthClient}/>}
            />
            <Route
                exact={true}
                path='/forgotPassword'
                component={(props: any) => <ForgotPassword setUser={setUser} {...props}
                                                           isViaForSchools={isViaForSchools}
                                                           authClient={AuthClient}/>}
            />
            <Route
                exact={true}
                path='/forgotPasswordConfirmation'
                component={(props: any) => <PasswordReset user={user} {...props}
                                                                       pageMode =  {ChangePwPageMode.FORGOT_CONFIRM}
                                                                       isViaForSchools={isViaForSchools}
                                                                       authClient={AuthClient}/>}
            />
            <Route
                exact={true}
                path='/resetPassword'
                component={(props: any) => <PasswordReset user={user} {...props}
                                                                       pageMode =  {ChangePwPageMode.RESET_PW}
                                                                       isViaForSchools={isViaForSchools}
                                                                       authClient={AuthClient}/>}
            />
            <Route
                exact={true}
                path='/citySelector'
                component={(props: any) => <CitySelector {...props} isViaForSchools={isViaForSchools} stage={stage}/>}
            />
            <Route render={() => <Redirect to="/loading" />} />
        </Switch>
    );
};

export default withRouter(injectIntl(Auth));
